"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.134 6.542l-2.315 4.276-1.767 3.171-2.964-2.541-2.087 2.028L6 8.434c0-.322.269-.583.6-.583h6.471L14.073 6l1.061.542zM10.51 15.08L8.928 18l-1.06-.541.783-1.446H6.6a.592.592 0 01-.6-.582v-.304l2.14-2.08 2.37 2.032zm.89-5.188a.888.888 0 00-.9-.874c-.497 0-.9.391-.9.874s.403.875.9.875.9-.392.9-.875zm6.6 5.54a.592.592 0 01-.6.583h-6.04l2.348-4.337L18 15.267v.164zm0-1.703l-3.718-3.11 1.499-2.768h1.618c.332 0 .6.262.6.584L18 13.728z" }), "NoImage");
//# sourceMappingURL=NoImage.js.map